module.exports = __webpack_public_path__ + "static/lordofwar-Optimized.250be7e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client-screens/lordofwar-Optimized.png
// module id = 609
// module chunks = 213720915766396